import {
  DataObjectId,
  GroupChat,
  groupChatContainerId,
  GroupChatUsers,
  Hub,
  SandboxTree
} from 'yougile-model'

export class GroupChatsClient {
  public static createChat(
    sandbox: SandboxTree,
    users: GroupChatUsers,
    title?: string
  ): DataObjectId {
    const hub = GroupChat.create(sandbox.companyId, users, title)
    sandbox.add(hub, groupChatContainerId, false, false)
    return hub.id
  }

  public static listChats(sandbox: SandboxTree, forUser?: DataObjectId): Hub[] {
    if (!sandbox.get(groupChatContainerId)) {
      return []
    }
    if (!forUser) {
      return sandbox.getChildrenHubs(groupChatContainerId)
    } else {
      return sandbox
        .getChildrenHubs(groupChatContainerId)
        .filter(c => !!GroupChat.getParticipants(c)[forUser])
    }
  }
}
